if ("IntersectionObserver" in window || !!window.IntersectionObserver) {
	var sectionObserver = new IntersectionObserver(
		function (entries, observer) {
			var anyAreIntersecting = false;
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					anyAreIntersecting = true;

					entry.target.classList.add("reveal:shown");
					entry.target.classList.add("reveal:visible");
				} else {
					entry.target.classList.remove("reveal:visible");
				}
			});
			if (anyAreIntersecting) {
			} else {
			}
		},
		{ threshold: 0.25 }
	);

	var containers = document.querySelectorAll("main");
	// console.log(containers);

	containers.forEach(function (container) {
		for (var element of container.children) {
			element.classList.add("reveal");
			element.classList.add("reveal:active");
			sectionObserver.observe(element);
		}
	});
}
